module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="l-grid-layout-33">\r\n	<div class="b-person-email">\r\n		<span class="js-widget"  onclick=\'return new Widgets.Input({ bindingProperty: "emails", label: L10N.get("pages.booking.bookingForm.email"), deletableField: true })\'></span>\r\n	</div>\r\n</div>\r\n';

}
return __p
}